import { Product } from 'types/productType';
import { httpGet } from 'utils';

interface Params {
  portfolioId?: number;
  page?: number;
  pageSize?: number;
}

interface MyCellarResponse {
  data: Product[];
  size?: number;
  totalCount?: number;
  page?: number;
  pageSize?: number;
  totalPages?: number;
}

interface GetDetailsParams {
  assetUnitId: string;
}

// Fetch a single page with default page size for faster initial load
export const fetchMyCellarPaged = (page = 0, pageSize = 20, portfolioId?: number) =>
  httpGet<MyCellarResponse, Params>('portal/Cellar', {
    page,
    pageSize,
    ...(portfolioId && { portfolioId }),
  });

export const fetchMyCellarDetails = (params: GetDetailsParams) =>
  httpGet<Product, GetDetailsParams>('portal/CellarDetail', params);

// Cellar stats API response
interface RegionStat {
  region: string;
  totalCount: number;
}

interface CellarStatsResponse {
  totalValue: number;
  totalBottle: number;
  totalCases: number;
  regionStats: RegionStat[];
  uniqueLwin18: number;
}

interface CellarStatsParams {
  portfolioId: number;
}

export const fetchCellarStats = (portfolioId: number) =>
  httpGet<CellarStatsResponse, CellarStatsParams>('portal/CellarStats', { portfolioId });
